module.exports = __webpack_public_path__ + "static/laboheme3s-024fd732ce87887c3e7b7183fd41ebfa.jpg";